<div class="d-flex justify-content-center">
    <img [src]="imageSrc" [ngClass]="{'img-fluid profile-img-pickup' : true, 'profile-img-empty': imageSrc == ''}"
        (click)="openImgPickup()" />
    <input class="img-input-pickup" #imgPickup name="imageUrl" type="file" accept="image/*"
        (change)="handleInputChange($event)" />
    <input type="hidden" class="form-control" #imageInputHidden />
</div>